module.exports = __webpack_public_path__ + "static/company-logo.65d66f56.jpg";